// extracted by mini-css-extract-plugin
export var currencyInput = "_ky-1";
export var currencySymbol = "_ky-0";